import HttpClient from '@/repositories/clients/httpClient';

/**
 * Event API service for event-related endpoints (days-off-balance, check-days-off).
 * Uses the standard app httpClient with existing authentication.
 */
class EventApiService {

  /**
   * Fetch the days-off balance for a given promoter.
   */
  async getDaysOffBalance() {
    const response = await HttpClient.get(`/event/days-off-balance`);
    return response.data?.data || response.data;
  }

  /**
   * Check if a days-off request is acceptable (sufficient balance).
   * @param {string} startDate - Start date in YYYY-MM-DD format
   * @param {string} endDate - End date in YYYY-MM-DD format
   */
  async checkDaysOff(startDate, endDate) {
    const response = await HttpClient.post('/event/check-days-off', {
      start_date: startDate,
      end_date: endDate,
    });
    return response.data?.data || response.data;
  }

  /**
   * Create a planning CRA event on the backend.
   * @param {Object} payload - Event data matching the backend API contract
   * @returns {Object} The created event data from the backend
   */
  async createEvent(payload) {
    const response = await HttpClient.post('/event', payload);
    return response.data?.data || response.data;
  }

  /**
   * Update a planning CRA event on the backend.
   * @param {number} id - The event ID to update
   * @param {Object} payload - Event data to update
   * @returns {Object} The updated event data from the backend
   */
  async updateEvent(id, payload) {
    const response = await HttpClient.put(`/event/${id}`, payload);
    return response.data?.data || response.data;
  }

  /**
   * Delete a planning CRA event on the backend.
   * @param {number} id - The event ID to delete
   * @returns {Object} The deletion result from the backend
   */
  async deleteEvent(id) {
    const response = await HttpClient.delete(`/event/${id}`);
    return response.data?.data || response.data;
  }
}

export default new EventApiService();
